import axios from 'axios';

export default {
    fetchForEmployeeAndDate(employeeId, date) {
        return axios
            .post('/timeline/fetchForEmployeeAndDate/', {
                forEmployeeId: employeeId,
                date,
            })
            .then((res) => res.data.data);
    },
};
